
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.14.1
 * Query Engine version: d9a4c5988f480fa576d43970d5a23641aa77bc9c
 */
Prisma.prismaVersion = {
  client: "4.14.1",
  engine: "d9a4c5988f480fa576d43970d5a23641aa77bc9c"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val


/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.Awsdms_ddl_auditScalarFieldEnum = {
  c_key: 'c_key',
  c_time: 'c_time',
  c_user: 'c_user',
  c_txn: 'c_txn',
  c_tag: 'c_tag',
  c_oid: 'c_oid',
  c_name: 'c_name',
  c_schema: 'c_schema',
  c_ddlqry: 'c_ddlqry'
};

exports.Prisma.BotTemplatesScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  detailsHtml: 'detailsHtml',
  gifUrl: 'gifUrl',
  trigger: 'trigger',
  slug: 'slug',
  tags: 'tags',
  emoji: 'emoji',
  detailsPageHtml: 'detailsPageHtml'
};

exports.Prisma.ChannelsScalarFieldEnum = {
  slack_id: 'slack_id',
  name: 'name',
  team: 'team',
  is_private: 'is_private',
  workspace: 'workspace',
  is_deleted: 'is_deleted',
  is_archived: 'is_archived',
  enterprise: 'enterprise',
  is_org_shared: 'is_org_shared'
};

exports.Prisma.CompaniesScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  name: 'name',
  domain: 'domain',
  size: 'size',
  industry: 'industry',
  people_data_raw: 'people_data_raw',
  linkedin_id: 'linkedin_id'
};

exports.Prisma.CustomFieldsScalarFieldEnum = {
  id: 'id',
  communityUserId: 'communityUserId',
  email: 'email',
  location: 'location',
  name: 'name',
  refferalSource: 'refferalSource',
  walletAddress: 'walletAddress',
  twitter: 'twitter',
  properties: 'properties'
};

exports.Prisma.Custom_at_risk_usersScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  team: 'team',
  workspace: 'workspace',
  active_period_start: 'active_period_start',
  inactive_period_start: 'inactive_period_start'
};

exports.Prisma.Directory_industry_experienceScalarFieldEnum = {
  id: 'id',
  team: 'team',
  name: 'name',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.Directory_industry_experience_userScalarFieldEnum = {
  id: 'id',
  team: 'team',
  industry_experience: 'industry_experience',
  created_at: 'created_at',
  directory_user: 'directory_user'
};

exports.Prisma.Directory_skillsScalarFieldEnum = {
  id: 'id',
  team: 'team',
  name: 'name',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.Directory_skills_userScalarFieldEnum = {
  id: 'id',
  team: 'team',
  skill: 'skill',
  created_at: 'created_at',
  directory_user: 'directory_user'
};

exports.Prisma.Directory_teamsScalarFieldEnum = {
  slack_id: 'slack_id',
  name: 'name',
  created_at: 'created_at',
  directory_custom_info: 'directory_custom_info'
};

exports.Prisma.Directory_usersScalarFieldEnum = {
  slack_id: 'slack_id',
  name: 'name',
  team: 'team',
  is_admin: 'is_admin',
  is_owner: 'is_owner',
  image_32: 'image_32',
  is_bot: 'is_bot',
  updated_ts: 'updated_ts',
  updated_formatted_ts: 'updated_formatted_ts',
  joined_formatted_ts: 'joined_formatted_ts',
  image_512: 'image_512',
  is_deleted: 'is_deleted',
  is_invited: 'is_invited',
  directory_bio: 'directory_bio',
  directory_edited: 'directory_edited',
  directory_visible: 'directory_visible',
  directory_interest_free_text: 'directory_interest_free_text',
  directory_looking: 'directory_looking',
  directory_experience: 'directory_experience',
  directory_twitter: 'directory_twitter',
  directory_linkedin: 'directory_linkedin',
  directory_location: 'directory_location',
  directory_title: 'directory_title',
  directory_pronouns: 'directory_pronouns',
  tz_label: 'tz_label',
  tz: 'tz',
  directory_connecting: 'directory_connecting',
  directory_moderator: 'directory_moderator',
  workspace: 'workspace',
  display_name: 'display_name'
};

exports.Prisma.DiscordCategoryScalarFieldEnum = {
  id: 'id',
  guild: 'guild',
  workspace: 'workspace',
  name: 'name',
  type: 'type',
  status: 'status',
  categoryId: 'categoryId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.DiscordChannelScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  type: 'type',
  guildId: 'guildId',
  createdAtDiscord: 'createdAtDiscord',
  parentId: 'parentId',
  workspace: 'workspace'
};

exports.Prisma.DiscordGeneratedChannelScalarFieldEnum = {
  id: 'id',
  channelId: 'channelId',
  guild: 'guild',
  workspace: 'workspace',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  name: 'name',
  isDeleted: 'isDeleted',
  category: 'category'
};

exports.Prisma.DiscordGeneratedThreadScalarFieldEnum = {
  id: 'id',
  discordId: 'discordId',
  name: 'name',
  channelId: 'channelId',
  guildId: 'guildId',
  workspace: 'workspace',
  type: 'type',
  locked: 'locked',
  archived: 'archived',
  autoArchiveDuration: 'autoArchiveDuration',
  createOffMessage: 'createOffMessage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  metadata: 'metadata'
};

exports.Prisma.DiscordGuildScalarFieldEnum = {
  id: 'id',
  name: 'name',
  joinedTs: 'joinedTs',
  updatedAt: 'updatedAt',
  workspaceId: 'workspaceId',
  isActive: 'isActive',
  sendDailyDigest: 'sendDailyDigest',
  lastSyncedAt: 'lastSyncedAt',
  dotsAdminChannel: 'dotsAdminChannel',
  stripeUserId: 'stripeUserId'
};

exports.Prisma.DiscordMemberScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  guildId: 'guildId',
  discordId: 'discordId',
  discriminator: 'discriminator',
  username: 'username',
  updatedAt: 'updatedAt',
  avatar: 'avatar',
  isBot: 'isBot',
  joinedAt: 'joinedAt',
  workspace: 'workspace',
  lastSyncedAt: 'lastSyncedAt',
  isDeleted: 'isDeleted'
};

exports.Prisma.DiscordRoleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  guildId: 'guildId',
  workspace: 'workspace',
  hex_color: 'hex_color',
  is_admin_role: 'is_admin_role',
  permissions: 'permissions',
  hierarchy_position: 'hierarchy_position',
  save_messages_allowed: 'save_messages_allowed'
};

exports.Prisma.DiscordSavedMessagesScalarFieldEnum = {
  id: 'id',
  guildId: 'guildId',
  channelId: 'channelId',
  savedBy: 'savedBy',
  workspace: 'workspace',
  channelName: 'channelName',
  author: 'author',
  username: 'username',
  content: 'content',
  type: 'type',
  sentiment: 'sentiment',
  confidenceScores: 'confidenceScores',
  textAnalysis: 'textAnalysis',
  avatarUrl: 'avatarUrl',
  messageUrl: 'messageUrl',
  isBot: 'isBot',
  createdAtDiscord: 'createdAtDiscord',
  createdAt: 'createdAt'
};

exports.Prisma.DiscordSavedMsgTagsScalarFieldEnum = {
  id: 'id',
  tag: 'tag',
  savedMsgId: 'savedMsgId',
  guildId: 'guildId',
  workspace: 'workspace',
  createdAt: 'createdAt'
};

exports.Prisma.DiscordUserTagsScalarFieldEnum = {
  id: 'id',
  tag: 'tag',
  createdAt: 'createdAt',
  source: 'source',
  workspace: 'workspace',
  discordMemberId: 'discordMemberId',
  guildId: 'guildId'
};

exports.Prisma.DiscordVoiceChannelSessionScalarFieldEnum = {
  id: 'id',
  guildId: 'guildId',
  channelId: 'channelId',
  startedAt: 'startedAt',
  updatedAt: 'updatedAt',
  peakMemberCount: 'peakMemberCount',
  durationSeconds: 'durationSeconds',
  workspace: 'workspace'
};

exports.Prisma.DiscordVoiceUserSessionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  guildId: 'guildId',
  channelId: 'channelId',
  startedAt: 'startedAt',
  updatedAt: 'updatedAt',
  durationSeconds: 'durationSeconds',
  workspace: 'workspace'
};

exports.Prisma.Discord_guild_triggersScalarFieldEnum = {
  id: 'id',
  type: 'type',
  guild: 'guild',
  created_at: 'created_at',
  updated_at: 'updated_at',
  name: 'name',
  active: 'active',
  config: 'config',
  created_by_old: 'created_by_old',
  created_by: 'created_by',
  workspace: 'workspace'
};

exports.Prisma.Discord_guild_usersScalarFieldEnum = {
  discord_id: 'discord_id',
  username: 'username',
  discriminator: 'discriminator',
  avatar: 'avatar',
  joined_ts: 'joined_ts',
  is_bot: 'is_bot',
  guild: 'guild',
  workspace: 'workspace'
};

exports.Prisma.Discord_member_rolesScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  member: 'member',
  role: 'role',
  guild: 'guild',
  workspace: 'workspace'
};

exports.Prisma.Discord_members_channelsScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  discord_member: 'discord_member',
  discord_channel: 'discord_channel',
  guild: 'guild',
  workspace: 'workspace'
};

exports.Prisma.Discord_msg_reactionsScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  message: 'message',
  member: 'member',
  emoji: 'emoji',
  guild: 'guild',
  channel: 'channel',
  workspace: 'workspace',
  author: 'author',
  created_at_discord: 'created_at_discord',
  thread_message: 'thread_message'
};

exports.Prisma.Discord_onboarding_channelsScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  guild: 'guild',
  channel_id: 'channel_id',
  name: 'name',
  category: 'category',
  is_deleted: 'is_deleted',
  workspace: 'workspace'
};

exports.Prisma.Discord_parent_msgsScalarFieldEnum = {
  discord_id: 'discord_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  content: 'content',
  clean_content: 'clean_content',
  created_at_discord: 'created_at_discord',
  edited_at_discord: 'edited_at_discord',
  author: 'author',
  channel: 'channel',
  guild: 'guild',
  reaction_count: 'reaction_count',
  type: 'type',
  url: 'url',
  member: 'member',
  workspace: 'workspace',
  reference: 'reference'
};

exports.Prisma.Discord_scheduled_tasksScalarFieldEnum = {
  id: 'id',
  scheduled_time_utc: 'scheduled_time_utc',
  guild: 'guild',
  run_function: 'run_function',
  payload: 'payload',
  scheduled_time_local: 'scheduled_time_local',
  timezone: 'timezone',
  created_at: 'created_at',
  status: 'status',
  workspace: 'workspace'
};

exports.Prisma.Discord_thread_msgsScalarFieldEnum = {
  discord_id: 'discord_id',
  created_at: 'created_at',
  content: 'content',
  clean_content: 'clean_content',
  discord_thread: 'discord_thread',
  discord_channel: 'discord_channel',
  discord_member: 'discord_member',
  author: 'author',
  created_at_discord: 'created_at_discord',
  guild: 'guild',
  workspace: 'workspace',
  reaction_count: 'reaction_count',
  reaction_members: 'reaction_members',
  url: 'url'
};

exports.Prisma.Discord_threadsScalarFieldEnum = {
  discord_id: 'discord_id',
  created_at: 'created_at',
  name: 'name',
  created_at_discord: 'created_at_discord',
  archived: 'archived',
  auto_archive_duration: 'auto_archive_duration',
  discord_channel: 'discord_channel',
  member_count: 'member_count',
  guild: 'guild',
  workspace: 'workspace',
  archive_timestamp: 'archive_timestamp'
};

exports.Prisma.Discord_usersScalarFieldEnum = {
  discord_id: 'discord_id',
  guild: 'guild',
  username: 'username',
  discriminator: 'discriminator',
  avatar: 'avatar',
  auth_users_uid: 'auth_users_uid',
  approved: 'approved',
  email: 'email',
  timezone: 'timezone',
  discord_user_id: 'discord_user_id',
  workspace: 'workspace',
  created_at: 'created_at'
};

exports.Prisma.Dots_adminsScalarFieldEnum = {
  id: 'id',
  team: 'team',
  auth_users_uid: 'auth_users_uid'
};

exports.Prisma.Dots_user_feedbackScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  user_id: 'user_id',
  workspace: 'workspace',
  community: 'community',
  type: 'type',
  content: 'content'
};

exports.Prisma.Enterprise_slack_user_channelsScalarFieldEnum = {
  slack_id: 'slack_id',
  slack_user: 'slack_user',
  channel: 'channel',
  created_at: 'created_at',
  workspace: 'workspace'
};

exports.Prisma.Floppy_channelsScalarFieldEnum = {
  slack_id: 'slack_id',
  name: 'name',
  team: 'team',
  created_at: 'created_at'
};

exports.Prisma.Floppy_parent_msgsScalarFieldEnum = {
  slack_id: 'slack_id',
  team: 'team',
  channel: 'channel',
  slack_user: 'slack_user',
  reply_users: 'reply_users',
  reply_count: 'reply_count',
  reaction_count: 'reaction_count',
  text: 'text',
  formatted_ts: 'formatted_ts',
  created_at: 'created_at',
  permalink: 'permalink',
  raw_text: 'raw_text'
};

exports.Prisma.Floppy_slack_usersScalarFieldEnum = {
  slack_id: 'slack_id',
  name: 'name',
  team: 'team',
  created_at: 'created_at',
  display_name: 'display_name',
  image_32: 'image_32',
  image_512: 'image_512'
};

exports.Prisma.Floppy_thread_msgsScalarFieldEnum = {
  slack_id: 'slack_id',
  team: 'team',
  channel: 'channel',
  slack_user: 'slack_user',
  parent_msg: 'parent_msg',
  formatted_ts: 'formatted_ts',
  created_at: 'created_at',
  text: 'text',
  reaction_count: 'reaction_count',
  raw_text: 'raw_text'
};

exports.Prisma.Github_tempScalarFieldEnum = {
  id: 'id',
  installation_id: 'installation_id',
  repository_name: 'repository_name',
  sender: 'sender',
  repository_full_name: 'repository_full_name',
  repository_id: 'repository_id',
  permissions: 'permissions',
  created_at: 'created_at'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.Keywords_trackerScalarFieldEnum = {
  id: 'id',
  keyword: 'keyword',
  updated_at: 'updated_at',
  created_at: 'created_at',
  team: 'team',
  workspace: 'workspace'
};

exports.Prisma.Message_templatesScalarFieldEnum = {
  id: 'id',
  team: 'team',
  name: 'name',
  text: 'text',
  created_at: 'created_at',
  workspace: 'workspace'
};

exports.Prisma.Msg_reactionsScalarFieldEnum = {
  slack_id: 'slack_id',
  parent_msg: 'parent_msg',
  slack_user: 'slack_user',
  channel: 'channel',
  name: 'name',
  thread_msg: 'thread_msg',
  team: 'team',
  formatted_ts: 'formatted_ts',
  workspace: 'workspace',
  created_at: 'created_at'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.Parent_msgsScalarFieldEnum = {
  slack_id: 'slack_id',
  channel: 'channel',
  text: 'text',
  reply_users: 'reply_users',
  reply_count: 'reply_count',
  reaction_count: 'reaction_count',
  time_to_first_reply: 'time_to_first_reply',
  team: 'team',
  ts: 'ts',
  timestamp: 'timestamp',
  activity_score: 'activity_score',
  formatted_ts: 'formatted_ts',
  slack_user: 'slack_user',
  permalink: 'permalink',
  to_reply_status: 'to_reply_status',
  num_files: 'num_files',
  is_bot: 'is_bot',
  raw_text: 'raw_text',
  assigned_to: 'assigned_to',
  workspace: 'workspace'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.RecordsScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  workspace: 'workspace',
  name: 'name',
  people_data_id: 'people_data_id',
  role: 'role',
  raw_people_data: 'raw_people_data',
  slack_user: 'slack_user',
  email: 'email',
  workspace_company: 'workspace_company'
};

exports.Prisma.Salesforce_accountsScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.Saved_surveysScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  team: 'team',
  name: 'name',
  survey_content: 'survey_content',
  workspace: 'workspace',
  is_template: 'is_template'
};

exports.Prisma.ScheduledTaskScalarFieldEnum = {
  id: 'id',
  scheduledTimeUTC: 'scheduledTimeUTC',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  platform: 'platform',
  taskType: 'taskType',
  params: 'params',
  result: 'result',
  status: 'status',
  workspace: 'workspace'
};

exports.Prisma.Scheduled_tasksScalarFieldEnum = {
  id: 'id',
  scheduled_time_utc: 'scheduled_time_utc',
  team: 'team',
  created_by: 'created_by',
  run_function: 'run_function',
  payload: 'payload',
  scheduled_time_local: 'scheduled_time_local',
  timezone: 'timezone',
  created_at: 'created_at',
  status: 'status',
  name: 'name',
  slack_event_id: 'slack_event_id',
  workspace: 'workspace',
  sender: 'sender',
  trigger_invocation: 'trigger_invocation',
  step_number: 'step_number'
};

exports.Prisma.Slack_user_channelsScalarFieldEnum = {
  slack_id: 'slack_id',
  slack_user: 'slack_user',
  channel: 'channel',
  created_at: 'created_at',
  team: 'team',
  workspace: 'workspace'
};

exports.Prisma.Slack_user_groupsScalarFieldEnum = {
  slack_id: 'slack_id',
  created_at: 'created_at',
  name: 'name',
  team: 'team',
  workspace: 'workspace',
  description: 'description',
  date_create: 'date_create'
};

exports.Prisma.Slack_user_groups_usersScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  team: 'team',
  workspace: 'workspace',
  slack_user: 'slack_user',
  slack_user_group: 'slack_user_group'
};

exports.Prisma.Slack_usersScalarFieldEnum = {
  slack_id: 'slack_id',
  name: 'name',
  team: 'team',
  is_admin: 'is_admin',
  is_owner: 'is_owner',
  image_32: 'image_32',
  is_bot: 'is_bot',
  updated_ts: 'updated_ts',
  updated_formatted_ts: 'updated_formatted_ts',
  email: 'email',
  joined_formatted_ts: 'joined_formatted_ts',
  image_512: 'image_512',
  user_notes: 'user_notes',
  is_deleted: 'is_deleted',
  is_invited: 'is_invited',
  directory_bio: 'directory_bio',
  directory_edited: 'directory_edited',
  directory_visible: 'directory_visible',
  directory_interest_free_text: 'directory_interest_free_text',
  directory_looking: 'directory_looking',
  directory_experience: 'directory_experience',
  directory_twitter: 'directory_twitter',
  directory_linkedin: 'directory_linkedin',
  directory_location: 'directory_location',
  directory_title: 'directory_title',
  tz_label: 'tz_label',
  tz: 'tz',
  display_name: 'display_name',
  time_fetched_people_data_labs: 'time_fetched_people_data_labs',
  workspace: 'workspace',
  enterprise_slack_id: 'enterprise_slack_id'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.Spam_msgsScalarFieldEnum = {
  slack_id: 'slack_id',
  channel: 'channel',
  text: 'text',
  reply_users: 'reply_users',
  reply_count: 'reply_count',
  reaction_count: 'reaction_count',
  time_to_first_reply: 'time_to_first_reply',
  team: 'team',
  ts: 'ts',
  timestamp: 'timestamp',
  activity_score: 'activity_score',
  formatted_ts: 'formatted_ts',
  slack_user: 'slack_user',
  permalink: 'permalink',
  status: 'status',
  reported_at: 'reported_at',
  reported_by: 'reported_by',
  updated_at: 'updated_at',
  direct_message: 'direct_message',
  channel_name: 'channel_name',
  thread_ts: 'thread_ts',
  reported_message_id: 'reported_message_id',
  type: 'type',
  hash: 'hash',
  reported_text: 'reported_text',
  workspace: 'workspace'
};

exports.Prisma.StripeUserScalarFieldEnum = {
  id: 'id',
  stripeId: 'stripeId',
  email: 'email',
  trialEnd: 'trialEnd',
  trialTier: 'trialTier',
  status: 'status',
  tier: 'tier',
  paymentMethodExists: 'paymentMethodExists',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.Survey_responsesScalarFieldEnum = {
  id: 'id',
  question_id: 'question_id',
  team: 'team',
  workspace: 'workspace',
  slack_user: 'slack_user',
  response: 'response',
  survey_id: 'survey_id',
  created_at: 'created_at'
};

exports.Prisma.Svix_integrationsScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  app_id: 'app_id',
  workspace: 'workspace',
  key: 'key'
};

exports.Prisma.TagsMsgsScalarFieldEnum = {
  id: 'id',
  name: 'name',
  guildId: 'guildId',
  color: 'color',
  workspace: 'workspace',
  createdAt: 'createdAt'
};

exports.Prisma.TagsScalarFieldEnum = {
  id: 'id',
  team: 'team',
  name: 'name',
  createdAt: 'createdAt',
  color: 'color',
  description: 'description',
  workspace: 'workspace',
  guildId: 'guildId'
};

exports.Prisma.Team_triggersScalarFieldEnum = {
  id: 'id',
  type: 'type',
  team: 'team',
  created_at: 'created_at',
  updated_at: 'updated_at',
  created_by: 'created_by',
  name: 'name',
  config: 'config',
  active: 'active',
  trigger_config: 'trigger_config',
  workspace: 'workspace',
  is_deleted: 'is_deleted'
};

exports.Prisma.TeamsScalarFieldEnum = {
  slack_id: 'slack_id',
  token: 'token',
  name: 'name',
  created_at: 'created_at',
  settings_exclude_channels: 'settings_exclude_channels',
  scope: 'scope',
  floppy_settings: 'floppy_settings',
  is_inactive: 'is_inactive',
  uses_directory: 'uses_directory',
  directory_custom_info: 'directory_custom_info',
  twitter_ids: 'twitter_ids',
  alias: 'alias',
  api_key: 'api_key',
  workspace: 'workspace',
  admin_channel: 'admin_channel',
  paid_user: 'paid_user',
  trial_end: 'trial_end',
  top_member_post_frequency: 'top_member_post_frequency',
  top_member_post_channel: 'top_member_post_channel',
  top_member_post_enabled: 'top_member_post_enabled',
  top_member_post_day: 'top_member_post_day',
  top_member_post_time: 'top_member_post_time',
  top_member_post_last_sent: 'top_member_post_last_sent',
  bot_name: 'bot_name',
  bot_icon: 'bot_icon',
  timezone: 'timezone',
  slack_api_error: 'slack_api_error'
};

exports.Prisma.Test_tableScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  name: 'name'
};

exports.Prisma.Thread_msgsScalarFieldEnum = {
  slack_id: 'slack_id',
  parent_msg: 'parent_msg',
  slack_user: 'slack_user',
  channel: 'channel',
  team: 'team',
  ts: 'ts',
  formatted_ts: 'formatted_ts',
  text: 'text',
  parent_slack_user: 'parent_slack_user',
  reaction_count: 'reaction_count',
  num_files: 'num_files',
  is_bot: 'is_bot',
  raw_text: 'raw_text',
  workspace: 'workspace'
};

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.TriggerInvocationScalarFieldEnum = {
  id: 'id',
  triggerId: 'triggerId',
  stepId: 'stepId',
  variables: 'variables',
  scheduledTaskId: 'scheduledTaskId',
  scheduledNextStepCount: 'scheduledNextStepCount',
  workspace: 'workspace',
  createdAt: 'createdAt',
  rootId: 'rootId',
  updatedAt: 'updatedAt'
};

exports.Prisma.TriggerScalarFieldEnum = {
  id: 'id',
  type: 'type',
  platform: 'platform',
  communityId: 'communityId',
  authorUserId: 'authorUserId',
  createdAt: 'createdAt',
  workspace: 'workspace',
  isActive: 'isActive',
  parentId: 'parentId',
  configs: 'configs',
  name: 'name',
  updatedAt: 'updatedAt',
  rootId: 'rootId',
  draftId: 'draftId',
  isDraft: 'isDraft',
  isArchived: 'isArchived'
};

exports.Prisma.TriggerStepScalarFieldEnum = {
  id: 'id',
  platform: 'platform',
  communityId: 'communityId',
  triggerId: 'triggerId',
  type: 'type',
  configs: 'configs',
  workspace: 'workspace',
  isEntry: 'isEntry',
  createdAt: 'createdAt',
  isGoal: 'isGoal',
  if: 'if',
  name: 'name'
};

exports.Prisma.TriggerTransitionScalarFieldEnum = {
  id: 'id',
  stepId: 'stepId',
  triggerId: 'triggerId',
  targetStepId: 'targetStepId',
  when: 'when',
  workspace: 'workspace',
  createdAt: 'createdAt',
  name: 'name'
};

exports.Prisma.Trigger_invocationsScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  team: 'team',
  workspace: 'workspace',
  team_trigger: 'team_trigger',
  slack_event_id: 'slack_event_id',
  target_user: 'target_user'
};

exports.Prisma.Trigger_responsesScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  community_id: 'community_id',
  username: 'username',
  discriminator: 'discriminator',
  question: 'question',
  answer: 'answer',
  step_id: 'step_id',
  task_type: 'task_type',
  trigger_id: 'trigger_id',
  root_trigger_id: 'root_trigger_id',
  execution_id: 'execution_id',
  workspace: 'workspace',
  root_execution_id: 'root_execution_id',
  discordGuildId: 'discordGuildId'
};

exports.Prisma.UserDiscordTokenScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  tokenType: 'tokenType',
  scope: 'scope',
  refreshTokenRevoked: 'refreshTokenRevoked',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserWorkspacesScalarFieldEnum = {
  id: 'id',
  authUsersUuid: 'authUsersUuid',
  workspace: 'workspace',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.User_filtersScalarFieldEnum = {
  id: 'id',
  team: 'team',
  filter_type: 'filter_type',
  filter_settings: 'filter_settings',
  view: 'view',
  workspace: 'workspace',
  guild: 'guild'
};

exports.Prisma.User_notesScalarFieldEnum = {
  id: 'id',
  text: 'text',
  created_at: 'created_at',
  updated_at: 'updated_at',
  slack_user: 'slack_user',
  written_by: 'written_by',
  team: 'team',
  workspace: 'workspace'
};

exports.Prisma.User_tagsScalarFieldEnum = {
  id: 'id',
  team: 'team',
  user_id: 'user_id',
  tag: 'tag',
  created_at: 'created_at',
  source: 'source',
  workspace: 'workspace'
};

exports.Prisma.User_viewsScalarFieldEnum = {
  id: 'id',
  team: 'team',
  name: 'name',
  created_at: 'created_at',
  description: 'description',
  workspace: 'workspace',
  guild: 'guild'
};

exports.Prisma.UsersScalarFieldEnum = {
  slack_id: 'slack_id',
  token: 'token',
  name: 'name',
  team: 'team',
  stripe_customer_id: 'stripe_customer_id',
  payment_status: 'payment_status',
  email: 'email',
  settings_unsubscribed_weekly_email_digest: 'settings_unsubscribed_weekly_email_digest',
  created_at: 'created_at',
  updated_at: 'updated_at',
  auth_users_uid: 'auth_users_uid',
  onboarded: 'onboarded',
  settings: 'settings',
  settings_daily_slack_digest_subscribed: 'settings_daily_slack_digest_subscribed',
  onboarded_at: 'onboarded_at',
  onboarding_version: 'onboarding_version',
  last_loggedin: 'last_loggedin',
  approved: 'approved',
  scope: 'scope',
  timezone: 'timezone',
  workspace: 'workspace',
  weekly_at_risk_message_enabled: 'weekly_at_risk_message_enabled',
  unsubscribe_monthly_digest: 'unsubscribe_monthly_digest'
};

exports.Prisma.Word_cloudsScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  team: 'team',
  guild: 'guild',
  data: 'data',
  updated_at: 'updated_at',
  type: 'type',
  workspace: 'workspace'
};

exports.Prisma.WorkspaceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  svixAppId: 'svixAppId',
  trialEnd: 'trialEnd',
  paidUser: 'paidUser',
  apiKey: 'apiKey',
  slackEnterpriseId: 'slackEnterpriseId',
  slackEnterpriseName: 'slackEnterpriseName'
};

exports.Prisma.Workspaces_companiesScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  workspace: 'workspace',
  company: 'company'
};
exports.BillingStatus = {
  active: 'active',
  trialing: 'trialing',
  inactive: 'inactive',
  incomplete: 'incomplete',
  incomplete_expired: 'incomplete_expired',
  past_due: 'past_due',
  canceled: 'canceled'
};

exports.BillingTier = {
  free: 'free',
  pro: 'pro',
  business: 'business',
  custom: 'custom'
};

exports.Platform = {
  discord: 'discord',
  slack: 'slack'
};

exports.TaskStatus = {
  scheduled: 'scheduled',
  in_progress: 'in_progress',
  error: 'error',
  completed: 'completed',
  canceled: 'canceled'
};

exports.TaskType = {
  create_channel: 'create_channel',
  delete_channel: 'delete_channel',
  send_message: 'send_message',
  send_survey: 'send_survey',
  idle: 'idle',
  edit_roles: 'edit_roles',
  send_webhook: 'send_webhook',
  cancel_tasks: 'cancel_tasks',
  send_captcha: 'send_captcha',
  kick_member: 'kick_member',
  send_http_request: 'send_http_request',
  verify_email: 'verify_email',
  send_direct_message: 'send_direct_message',
  send_multiple_select: 'send_multiple_select',
  edit_channel_category: 'edit_channel_category',
  change_nickname: 'change_nickname',
  open_modal: 'open_modal',
  test_captcha: 'test_captcha',
  delete_message: 'delete_message',
  get_gif: 'get_gif',
  create_thread: 'create_thread',
  edit_dots_tags: 'edit_dots_tags',
  find_user: 'find_user',
  save_user_field: 'save_user_field'
};

exports.TriggerType = {
  team_join: 'team_join',
  channel_join: 'channel_join',
  command: 'command',
  role_change: 'role_change',
  message_create: 'message_create',
  button_click: 'button_click',
  receive_webhook: 'receive_webhook',
  time: 'time'
};

exports.Prisma.ModelName = {
  Trigger: 'Trigger',
  TriggerStep: 'TriggerStep',
  TriggerTransition: 'TriggerTransition',
  TriggerInvocation: 'TriggerInvocation',
  ScheduledTask: 'ScheduledTask',
  DiscordCategory: 'DiscordCategory',
  DiscordGeneratedChannel: 'DiscordGeneratedChannel',
  DiscordGeneratedThread: 'DiscordGeneratedThread',
  DiscordVoiceUserSession: 'DiscordVoiceUserSession',
  DiscordVoiceChannelSession: 'DiscordVoiceChannelSession',
  DiscordChannel: 'DiscordChannel',
  DiscordRole: 'DiscordRole',
  DiscordMember: 'DiscordMember',
  UserDiscordToken: 'UserDiscordToken',
  Workspace: 'Workspace',
  UserWorkspaces: 'UserWorkspaces',
  StripeUser: 'StripeUser',
  DiscordGuild: 'DiscordGuild',
  Tags: 'Tags',
  DiscordUserTags: 'DiscordUserTags',
  channels: 'channels',
  discord_member_roles: 'discord_member_roles',
  discord_msg_reactions: 'discord_msg_reactions',
  discord_parent_msgs: 'discord_parent_msgs',
  discord_thread_msgs: 'discord_thread_msgs',
  discord_threads: 'discord_threads',
  discord_users: 'discord_users',
  msg_reactions: 'msg_reactions',
  parent_msgs: 'parent_msgs',
  slack_users: 'slack_users',
  svix_integrations: 'svix_integrations',
  teams: 'teams',
  thread_msgs: 'thread_msgs',
  user_views: 'user_views',
  users: 'users',
  awsdms_ddl_audit: 'awsdms_ddl_audit',
  companies: 'companies',
  custom_at_risk_users: 'custom_at_risk_users',
  directory_industry_experience: 'directory_industry_experience',
  directory_industry_experience_user: 'directory_industry_experience_user',
  directory_skills: 'directory_skills',
  directory_skills_user: 'directory_skills_user',
  directory_teams: 'directory_teams',
  directory_users: 'directory_users',
  discord_guild_triggers: 'discord_guild_triggers',
  discord_guild_users: 'discord_guild_users',
  discord_members_channels: 'discord_members_channels',
  discord_onboarding_channels: 'discord_onboarding_channels',
  discord_scheduled_tasks: 'discord_scheduled_tasks',
  dots_admins: 'dots_admins',
  dots_user_feedback: 'dots_user_feedback',
  enterprise_slack_user_channels: 'enterprise_slack_user_channels',
  floppy_channels: 'floppy_channels',
  floppy_parent_msgs: 'floppy_parent_msgs',
  floppy_slack_users: 'floppy_slack_users',
  floppy_thread_msgs: 'floppy_thread_msgs',
  github_temp: 'github_temp',
  keywords_tracker: 'keywords_tracker',
  message_templates: 'message_templates',
  records: 'records',
  salesforce_accounts: 'salesforce_accounts',
  saved_surveys: 'saved_surveys',
  scheduled_tasks: 'scheduled_tasks',
  slack_user_channels: 'slack_user_channels',
  slack_user_groups: 'slack_user_groups',
  slack_user_groups_users: 'slack_user_groups_users',
  spam_msgs: 'spam_msgs',
  survey_responses: 'survey_responses',
  team_triggers: 'team_triggers',
  test_table: 'test_table',
  trigger_invocations: 'trigger_invocations',
  user_filters: 'user_filters',
  user_notes: 'user_notes',
  user_tags: 'user_tags',
  word_clouds: 'word_clouds',
  workspaces_companies: 'workspaces_companies',
  DiscordSavedMessages: 'DiscordSavedMessages',
  trigger_responses: 'trigger_responses',
  TagsMsgs: 'TagsMsgs',
  DiscordSavedMsgTags: 'DiscordSavedMsgTags',
  botTemplates: 'botTemplates',
  CustomFields: 'CustomFields'
};

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
